var $ = require('jquery');

/**
 * Selection grid that opens details/more form fields under each row.
 * Used in Extranet > Excavator Specification form
 * @class
 */

class SelectionGrid {
  private dom = {
    $el: null,
    $thumbnail: null,
    $radio: null,
    $modal: null,
    $copyPin1: null
  };

  private width: Number;

  constructor(private element) {
    this.dom.$el = $(element);
    this.dom.$thumbnail =  this.dom.$el.find('.selection-grid__thumbnail');
    this.dom.$radio =  this.dom.$el.find('.js-selection-grid__radio');
    this.dom.$modal =  this.dom.$el.find('.selection-grid__modal');
    this.dom.$copyPin1 =  this.dom.$el.find('.same_as_pin1 input[type="checkbox"]');

    this.width = this.dom.$el.width();

    //find active selection and open it
    const activeThumbnail = this.dom.$el.find('li.active .selection-grid__thumbnail').first();
    if(activeThumbnail.length) {
      this._openDetails(activeThumbnail);
    }

  }

  /**
   * Bind event listeners
   */
  private _bindEvents() {
    this.dom.$radio.on('change', (e) => this._onSelectionChange($(e.currentTarget)));

    //same as pin1 -checkbox
    this.dom.$copyPin1.on('click', (e) => this._onPinCopyClick($(e.currentTarget), '.pin--pin1'));

    $( window ).resize(() => this._onScreenResize());

  }

  /**
   * Handle selection change
   * @param {JQuery} input Changed input
   */
  private _onSelectionChange(input) {
    //previous element
    const thumbnail =  input.next();
    const prevActive = this.dom.$el.find('ul > .active').first();

    //if this is the first element or new element
    if(!prevActive.length || prevActive !== thumbnail) {

      //check if element has any values entered
      const hasValues = prevActive ? this._hasValues(prevActive) : false;

      if(prevActive.length && hasValues) {
        //user changed to new adapter and has values entered

        //dialog to make sure user wants to change adapter type
        this._confirmChange((confirmed) => {
          if(confirmed){
            this._openDetails(thumbnail);
            this._closeDetails(prevActive);
          }
        });

      } else if(prevActive.length) {
        //user changed to new adapter, but has not added any values (no need to confirm)
        this._openDetails(thumbnail);
        this._closeDetails(prevActive);

      } else {
      //this is the first adapter user chooses
        this._openDetails(thumbnail);
      }
    }

  }

  /**
   * Confirm the selection
   * @param {function} callback event that will happen after confirmation
   */
  private _confirmChange(callback) {

      this.dom.$modal.show();
      const buttons = this.dom.$modal.find('button');

      //event is unbound after its first invocation.
      buttons.one("click", (e) => {
        const button = $(e.currentTarget);
        if(button.data('dismiss')) {
          callback(false);
        } else {
          callback(true);
        }
        this.dom.$modal.hide();
      });

  }

  /**
   * Clear and disable inputs and hide the details element
   * @param {JQuery} element adapter element
   */
  private _closeDetails(element) {
    element.removeClass('active');
    element.find('.selection-grid__details').slideUp();

    const inputs = element.find('input[type="text"], input[type="number"]');
    inputs.prop('disabled', true);

    inputs.each(function() {
      $( this ).val('').blur();
    });
  }

  /**
   * Enable inputs and show the details element
   * @param {JQuery} element adapter element
   */
  private _openDetails(thumbnail) {
      //find elements
      const detailsElement = thumbnail.next('.selection-grid__details');
      const parentElement = thumbnail.parent('li');
      const inputs = detailsElement.find('input[type="text"], input[type="number"]');

      //set element as active
      parentElement.addClass('active');
      inputs.prop('disabled', false);

      //copy width from container, move element to the left edge, then show it
      const offsetX = thumbnail.position().left;
      const containerWidth = this.dom.$el.width();

      detailsElement.css( "left", -offsetX).width(containerWidth).slideDown();
  }

  /**
   * Check if element text inputs have values
   * @param {JQuery} element adapter element
   * @return {boolean}
   */
  private _hasValues(element) {
    let hasValue = false;
    const inputs = element.find('input[type="text"], input[type="number"]');

    inputs.each(function() {
      if ($( this ).val().length) {
        hasValue = true;
      }
    });

    return hasValue;
  }

  /**
   * Adjust element size/position on sreen resize
   */
  private _onScreenResize() {
    const openDetails = this.dom.$el.find('ul > .active .selection-grid__details');
    const thumbnail = openDetails.parent('li');
    const elementWidth = this.dom.$el.width();

    //if element width is changed and details are open, update details position
    if(elementWidth !== this.width && openDetails) {
      const offsetX = thumbnail.position().left;
      openDetails.css( "left", -offsetX).width(elementWidth);
      this.width = elementWidth;
    }
  }

  /**
   * Handle pin copy checkbox click
   * @param {JQuery} checkbox checkbox that was clicked
   * @param {String} fromSelector selector of the form pin element
   */
  private _onPinCopyClick(checkbox, fromSelector:string) {
    //set checkbox parent as target element
    const targetPin = checkbox.parents('.pin');

    //if checkbox is checked
    if(checkbox.is(':checked')) {
      const fromPin = this.dom.$el.find(fromSelector);
      this._copyPinValues(fromPin, targetPin);
    } else {
      //remove readOnly from inputs
      targetPin.find('input').prop("readonly", false).parent().removeClass('readOnly');
    }

  }

  /**
   * Copy pin values to current pin
   * @param {JQuery} fromPin element to copy values from
   * @param {JQuery} targetPin element to copy values to
   */
  private _copyPinValues(fromPin, targetPin) {
    //get values from subject element
    const inputLabels = fromPin.find('label');

    //find matching input
    inputLabels.each(function() {
      //from
      const labelText =  $( this ).html();
      const id =  $( this ).attr('for');
      const value =  fromPin.find('#' + id ).val();

      //to
      const toLabel = targetPin.find("label:contains('" + labelText  + "')");
      const toId = toLabel.attr('for');
      //set values and make readOnly
      targetPin.find('#' + toId ).val(value).prop("readonly", true).parent().addClass('readOnly');
    });

  }




  public init() {
    var self = this;

    if(!this.dom.$el.length) {
      return;
    }

    this._bindEvents();

  }
}

export { SelectionGrid };
